// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"a537e1ca","453":"6e4f956a"}[chunkId] + ".chunk.js";
};